(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[387],{

/***/ 54119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Blog/marketing/seller-protection-depop/index.tsx







function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "OneShop Team",
      dateTime: "2022-01-22",
      tag: "Depop",
      title: "Depop Seller Protection",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Many transactions nowadays are done online, and this does not exclude shopping. Hence, many successful online selling and shopping platforms like Depop, eBay, Poshmark, Mercari, Facebook marketplace, and many others. Now, earning from the comforts of your home is not impossible. Even those who have social media accounts can sell whatever they want to sell (only items that are allowed, of course) like on Instagram, and even those who have Twitter accounts.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Many people find selling at home using the internet convenient as it truly saves time and effort. Shoppers can safely shop online with each marketplaces' buyer protection as it shields them from counterfeit or fakes and getting items that have unmentioned flaws. So, it is understandable that many sellers, especially those who are just starting, may have doubts about whether they are protected, too. To set the records straight, most platforms protect sellers and buyers from different online scenarios like scams and fraud. And they give fair investigation before they arrive at a decision. So, if you are starting an online business, you must be aware of the seller protection that may save you from scammers and fraudsters."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["One of the most used online marketplaces in recent years is the Depop app, with millions of users from the United Kingdom, Australia, United States, and Italy. Aside from being accessible on the web, this marketplace is also available on iOS and android. On here, buyers can purchase a wide variety of menswear, womenswear, and jewelry, including vintage items, streetwear, or preloved casual wear. It also doesn't matter whether they are from your collection or the thrift stores. So, if you have items that fit the categories, you may start selling them here by simply creating a Depop account. Set up your account by starting with a profile photo, writing your bio, and connecting your social media to your store so you'd appear trustworthy and your followers would know where to find you. To help you boost your sales, mention in your bio that you offer free shipping on your items so you'll have a better chance of doubling your sales.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Read on and find out how sellers like you get protected by Depop with their Seller Protection."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "How It Works"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["The principle of Depop Seller Protection is straightforward. You only have to keep in mind that all sales made via the Depop BUY button are the only ones that Seller Protection covers. As with any online platform, it is a repetitive reminder to all users to always make all purchases in-app. All you have to do is follow Depop's guidelines, and they will extend help to make sure you don't lose out on any disputes.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "You are covered if:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "The sale is made inside the app using the BUY button."
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["The items you sell are not on the", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "https://depophelp.zendesk.com/hc/en-gb/articles/360001792167-What-are-Depop-s-prohibited-items-",
            children: "Prohibited Items List"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "The item that you sold is shipped to the address similar to what is in the Depop sales receipt"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "You have a valid proof of shipping information"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "You are not covered if:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "You made your sale outside the Depop platform. "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Your buyers made the payment via direct money transfers such as PayPal friends and family or bank transfers."
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["The item you sell is on the", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "https://depophelp.zendesk.com/hc/en-gb/articles/360001792167-What-are-Depop-s-prohibited-items-",
            children: "Depop's prohibited items list"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "You sold an item via in-person transactions"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "You made trades outside of the Depop BUY button"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Note:"
        }), " Depop discourages making Trades as this transaction is tricky and may put you at risk. If a transaction is not done inside the platform, Depop can offer no protection to the involved parties and from PayPal."]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "How To Resolve Disputes"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Many scenarios may arise when you are selling online. And as a seller, it is your responsibility to ensure that you professionally deal with them. Here are some situations and how you can win them on Depop."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "The buyer didn't receive the item."
        }), " This situation can mean two things. One, your buyer is telling the truth, and the parcel is lost in the mail, or two, your buyer is not telling the truth and is trying to scam you. The best way to avoid this situation is to always use tracked shipping. This way, not only does it will keep your buyer updated when they can expect their parcel to arrive, but it also ensures that you're covered by Depop seller protection.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["When this happens, and your buyer has filed a dispute against you, all you have to do is provide evidence to Depop. You should be able to prove that the item was sent and delivered via the tracked shipping label.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "The buyer claims the item is not as described."
        }), " To prove your innocence on this, you have to send evidence to Depop that the item was as exactly described. There will be a mediation between you and the buyer to arrive at a solution this time. If this fails, the platform will ask the buyer to return the item using tracked postage. Once the item is received, you will be issued a full refund, excluding the shipping fee."]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Note:"
        }), " On this kind of dispute, if the item is proven a counterfeit item, you must refund your buyer without returning your item (because shipping fake items are illegal)."]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "The buyer wants to return an item."
        }), " To deal with this kind of dispute, you have to ask your buyer to return your item with tracked postage. Once you have received the item, you may process the refund. If the buyer has already returned the item, Depop may process a refund on your behalf if you haven't yet."]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Staying under the seller protection of Depop is not that hard. If you want to have a smooth sailing selling journey on the platform, all you have to do is follow their seller guideline, and you should be able to sell without any hassle.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "OneShop as Your Partner"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Your online venture on marketplaces such as Poshmark, Mercari, Depop, and others can be as successful as you visioned it to be. But of course, all businesses won't become triumphant without consistent dedication, time, and effort.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Using an intelligent bot like OneShop can boost your presence on the platform. If you sell on Poshmark and Mercari and want to cross-list to Depop, OneShop is your best bet. There is no need to spend long periods manually copying every detail of your listing from one platform to another. All you have to do is draft your listings once, and you can import them effortlessly on every resale site OneShop supports.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Use your time wisely and do things that can grow your business and spend time with family without worrying about whether your shop is staying active or not. Depop automation is coming soon on OneShop, and we are excited to provide the best Depop automation software in the market."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/blog/seller-protection-depop.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "Depop Seller Protection"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "Sell on Depop with confidence with its Seller Protection. Learn here how it works and how you are protected!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://tools.oneshop.com/blog/seller-protection-depop"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://tools.oneshop.com/blog/seller-protection-depop"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "Depop Seller Protection"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "Sell on Depop with confidence with its Seller Protection. Learn here how it works and how you are protected!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=4"
      }, 'og-image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: "2022-01-22T00:00:00.000Z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: "2022-01-22T00:00:00.000Z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:tag",
        content: "Depop"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:publisher",
        content: "https://www.facebook.com/oneshopcompany"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 41206:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/seller-protection-depop",
      function () {
        return __webpack_require__(54119);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(41206); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);